<script setup lang="ts">
import getVehicleResponse from '@/types/responses/getVehicle';
import SelectCameraCheckBox from "@/components/CvrConvert/SelectCameraCheckBox.vue";
import i18n from '@/lang/i18n';
import { computed } from "vue";
import ValidationErrors from "@/components/Common/ValidationErrors.vue";
import {
  CVR_UPLOAD_REQUEST_SELECTABLE_CAMERA,
  CVR_UPLOAD_REQUEST_CHECK_INI_FILE_CAMERA_COLUMN,
  CVR_UPLOAD_REQUEST_ACTIVE_CAMERA_STATUS,
  CVR_UPLOAD_REQUEST_INACTIVE_CAMERA_STATUS,
  CAMERA_ON_KEY
} from "@/services/consts";

const emit = defineEmits(["update:modelValue", "changeStatusRequestButton"])
const props = defineProps<{
  modelValue: string[]
  reading: boolean
  vehicle: getVehicleResponse | null
  errors: string[]
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const defaultSelectedValue: string[] = [CVR_UPLOAD_REQUEST_SELECTABLE_CAMERA[CAMERA_ON_KEY]]

const errorMessages = computed(() => {
  let errors = []
  if (props.errors) return props.errors
  if (props.vehicle && !selectableCamera.value.length) errors.push(i18n.global.t('pages.cvr_uploads.requestPanel.emptyCameraSettings'))
  return errors
})

const SELECTABLE_CAMERA_LABELS = {
  "F": i18n.global.t('pages.cvr_uploads.cameraName.front'),
  "R": i18n.global.t('pages.cvr_uploads.cameraName.rear'),
  "I": i18n.global.t('pages.cvr_uploads.cameraName.in'),
  "S": i18n.global.t('pages.cvr_uploads.cameraName.side'),
}

const selectableCamera = computed(() => {
  if (!props.vehicle || props.reading) return []
  let selectable: string[] = []
  const parameters = JSON.parse(JSON.stringify(props.vehicle?.parameters))
  const common = parameters.common
  if (common[CAMERA_ON_KEY] == CVR_UPLOAD_REQUEST_INACTIVE_CAMERA_STATUS) {
    emit('update:modelValue', selectable)
    emit('changeStatusRequestButton', true)
    return selectable
  }

  selectable.push(CVR_UPLOAD_REQUEST_SELECTABLE_CAMERA[CAMERA_ON_KEY])
  const record = parameters.record
  Object.keys(record).forEach((key: string) => {
    if (CVR_UPLOAD_REQUEST_CHECK_INI_FILE_CAMERA_COLUMN.includes(key) && record[key] == CVR_UPLOAD_REQUEST_ACTIVE_CAMERA_STATUS) {
      selectable.push(CVR_UPLOAD_REQUEST_SELECTABLE_CAMERA[key])
    }
  })
  emit('update:modelValue', defaultSelectedValue)
  emit('changeStatusRequestButton', false)
  return selectable
})
</script>
<template>
  <div class="col-9">
    <p class="mb-0">
      {{ i18n.global.t('pages.cvr_uploads.requestCameraType') }}
    </p>
    <ValidationErrors :messages="errorMessages" />
    <div class="d-flex">
      <SelectCameraCheckBox
        v-model="modelValue"
        :items="SELECTABLE_CAMERA_LABELS"
        :selectableItems="selectableCamera"
        :disabled="!props.vehicle"
      />
    </div>
  </div>
</template>
